import axios from "axios";
import { makeAutoObservable } from "mobx";
import env from "../config/env";
import { toast } from "react-toastify";
import axiosInstance from "../config/api";


class MailchimpSignupStore {
  email: string = "";
  fullName: string = "";
  country: string = "";
  roles: "Student" | "Instructor" | "Host" | "" = "";
  interests: string[] = [];
  phone: any = "";

  constructor() {
    makeAutoObservable(this);
  }

  setEmail(val: string) {
    this.email = val;
  }
  setFullName(val: string) {
    this.fullName = val;
  }
  setLocation(val: string) {
    this.country = val;
  }
  setRoleChoice(val: "Student" | "Instructor" | "Host") {
    this.roles = val;
  }

  setInterests(list: string[]) {
    this.interests = list;
  }

  setPhone(val: any) {
    this.phone = val;
  }

  async submitToMailchimp() {
    try {
      const joinedInterests = this.interests.join(";");

      const payload = {
        email: this.email,
        fullName: this.fullName,
        country: this.country,
        roles: this.roles,
        interests: joinedInterests,
        phone: this.phone,
      };

      const response = await axiosInstance.post(
        `${env.API}/Profiles/mailchimp/subscribe`,
        payload
      );

      console.log("Mailchimp subscription success", response.data);
      //toast.success("Successfully subscribed!");
    } catch (error) {
      console.error("Error sending to Mailchimp:", error);
      //toast.error("Something went wrong. Please try again later.");
    }
  }

  async notifyMeMailchimp(email: string, course: string) {
    try {
      const payload = {
        email,
        course,
      };

      const response = await axios.post(
        `${env.API}/api/mailchimp/notify-me`,
        payload
      );

      console.log("Mailchimp notification subscription success", response.data);
      toast.success("You will be notified when the course is available.");
    } catch (error) {
      console.error("Error sending to Mailchimp:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  }
}

export const mailchimpStore = new MailchimpSignupStore();
